import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getAdmMyChartUserId } from './endpoints/getAdmMyChartUserId';
import { FEDERATED_PROFILES_TAGS, getFederatedUserProfile } from './endpoints/getFederatedUserProfile';
import { getPatientMyChartUserId } from './endpoints/getPatientMyChartUserId';
import { getRecentMedicationRefill } from './endpoints/getRecentMedicationRefill';
import { updatePersonalUserProfile } from './endpoints/updatePersonalUserProfile';

export const personalHealthApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getFederatedUserProfile: getFederatedUserProfile(builder),
      getRecentMedicationRefill: getRecentMedicationRefill(builder),
      updatePersonalUserProfile: updatePersonalUserProfile(builder),
      getPatientMyChartUserId: getPatientMyChartUserId(builder),
      getAdmMyChartUserId: getAdmMyChartUserId(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [FEDERATED_PROFILES_TAGS],
  });

export const {
  useGetFederatedUserProfileQuery,
  useGetRecentMedicationRefillQuery,
  useUpdatePersonalUserProfileMutation,
  useGetPatientMyChartUserIdQuery,
  useGetAdmMyChartUserIdQuery,
  useLazyGetPatientMyChartUserIdQuery,
  useLazyGetAdmMyChartUserIdQuery,
} = personalHealthApi;
